import type {
  Response,
  UnassignedApplicantResponse,
} from '@/lib/apollo/query/getUnassignedApplicants/query'

import type { TransformedUnassignedApplicantData, TransformedData } from './types'

export const toTransformedUnassignedApplicantData = (
  unassignedApplicant: UnassignedApplicantResponse,
): TransformedUnassignedApplicantData => ({
  ...unassignedApplicant,
})

export const toTransformedData = (response?: Response): TransformedData | undefined =>
  response === undefined
    ? undefined
    : {
        ...response.getUnassignedApplicants,
        results: response.getUnassignedApplicants.results.map(
          toTransformedUnassignedApplicantData,
        ),
      }
